export const partnerReturnNavigation = {
  assign: (url: string) => window.location.assign(url),
};
